<template>
  <div class="flex items-center xl:order-2 space-x-3 xl:space-x-0 rtl:space-x-reverse mx-1">
    <div>
      <button type="button"
        class="flex text-sm bg-gray-800 rounded-full xl:me-0 hover:ring-4 hover:ring-paletteLightGreen"
        id="user-menu-button" aria-expanded="false" aria-hidden="true" data-dropdown-toggle="user-dropdown">
        <span class="sr-only">{{ $t('userMenu.openUserMenu') }}</span>
        <img class="w-8 h-8 rounded-full" :src=generateIconURL(userStore.user.user_id)
          :alt="userStore.user.user_name.charAt(0)" />
      </button>
      <!-- Dropdown menu -->
      <div
        class="z-50 hidden my-4 text-base list-none bg-paletteDarkGreen divide-y divide-paletteDarkGreen rounded-xl shadow-sm border border-gray-300"
        id="user-dropdown">
        <div class="px-4 py-3">
          <span class="block text-sm text-white">{{ userStore.user.user_name }}</span>
          <span class="block text-sm text-gray-400 truncate">{{ userStore.user.user_email }}</span>
          <div class="flex items-center space-x-2 mt-2">
            <img src="@/assets/icons/coin.png" alt="Credits Icon" class="w-6 h-6" />
            <span class="text-white">{{ creditsLeft }}</span>
          </div>
        </div>
        <ul class="py-2" aria-labelledby="user-menu-button">
          <li>
            <a href="/dashboard"
              class="block px-4 py-2 text-sm text-white hover:bg-paletteLightGreen">{{ $t('userMenu.dashboard') }}</a>
          </li>
          <li>
            <a href="/settings"
              class="block px-4 py-2 text-sm text-white hover:bg-paletteLightGreen">{{ $t('userMenu.settings') }}</a>
          </li>
          <li>
            <button @click="signOut"
              class="block w-full text-left px-4 py-2 text-sm text-white hover:bg-paletteLightGreen">
              {{ $t('userMenu.signOut') }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, computed } from 'vue'
import { initFlowbite } from 'flowbite'
import { useUserStore } from '@/stores/users'
import { generateIconURL, creditsLeftFormatted } from '@/utils/userUtils'

const userStore = useUserStore()

const signOut = () => {
  userStore.logout()
  window.location.href = '/login'
}

const creditsLeft = computed(() => creditsLeftFormatted(userStore.billingCreditsLeft))

onMounted(() => {
  initFlowbite()
})

</script>
<style scoped></style>
